export default __webpack_public_path__ + "media/images/jvqmap/tip-dc92c4aa120134c38a7ea1eeed436558.png";